import React from "react";
import Navbar      from "./components/Navbar";
import Hero        from "./components/Hero";
import Services    from "./components/Services";
import HowItWorks  from "./components/HowItWorks";
import ContactForm from "./components/ContactForm";
import ChatWidget  from "./components/ChatWidget";
import Footer      from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <ContactForm />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
